module.exports = __webpack_public_path__ + "img/payment-4.4da4ee24.svg";